import React from "react";
import { Box } from "@mui/material";
import { DataGrid, GridColDef, GridPaginationModel } from "@mui/x-data-grid";

interface Props {
  rows: any[];
  columns: GridColDef[];
  loading?: boolean;
  getRowId?: (row: any) => any;

  pageSizeOptions?: number[];
  initialState?: any;

  rowCount?: number;
  paginationMode?: "client" | "server";
  paginationModel?: GridPaginationModel;
  onPaginationModelChange?: (model: GridPaginationModel) => void;
}

const DataTable: React.FC<Props> = ({
  rows,
  columns,
  loading = false,
  getRowId,

  pageSizeOptions,
  initialState,

  rowCount,
  paginationMode = "client",
  paginationModel,
  onPaginationModelChange,
}) => {
  return (
    <Box sx={{ height: 500, width: "100%" }}>
      <DataGrid
        rows={rows}
        columns={columns}
        getRowId={getRowId || ((row) => row._id)} // ✅ FIX
        loading={loading}
        pageSizeOptions={pageSizeOptions || [10, 20, 50]}
        rowCount={rowCount}
        paginationMode={paginationMode}
        paginationModel={paginationModel}
        onPaginationModelChange={onPaginationModelChange}
        initialState={
          initialState || {
            pagination: {
              paginationModel: { pageSize: 10, page: 0 },
            },
          }
        }
        pagination
        disableRowSelectionOnClick
       sx={{
  border: "none",

  // HEADER BG
  "& .MuiDataGrid-columnHeaders": {
    backgroundColor: "#f1f5f9",
  },

  // 🔥 IMPORTANT (THIS FIXES IT)
  "& .MuiDataGrid-columnHeaderTitleContainer": {
    justifyContent: "center",
  },

  "& .MuiDataGrid-columnHeaderTitle": {
    width: "100%",
    textAlign: "center",
    fontWeight: 700,
  },

  // CELL CENTER
  "& .MuiDataGrid-cell": {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    textAlign: "center",
  },

  "& .MuiDataGrid-row:hover": {
    backgroundColor: "#f9fafb",
  },
}}
      />
    </Box>
  );
};

export default DataTable;
